import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'tlp-app-base',
  templateUrl: './app-base.component.html',
  styleUrls: ['./app-base.component.css']
})

export abstract class AppBaseComponent {

  // Recursively find a parameter in the route hierarchy.
  findParameter(route: ActivatedRoute, paramName: string): string | null {
   if (route.snapshot.paramMap.has(paramName)) {
     return route.snapshot.paramMap.get(paramName);
   } else if (route.parent) {
     return this.findParameter(route.parent, paramName);
   } else {
     return null;
   }
 }

 // Resolve a data key which might be a direct value or a route parameter token (e.g., ':tenantId')
 resolveDataOrParam(route: ActivatedRoute, dataKey: string): any | null {
   const rawValue = this.findData(route, dataKey);

   if (rawValue && typeof rawValue === 'string' && rawValue.startsWith(':')) {
     const paramName = rawValue.substring(1);
     const resolvedParam = this.findParameter(route, paramName);
     if (!resolvedParam) {
       console.error(`AppBaseComponent: Could not resolve route parameter '${paramName}' for data key '${dataKey}'.`);
       // Optionally, throw an error or return a specific indicator? Returning null for now.
       return null;
     }
     return resolvedParam;
   } else {
     // Return the raw value if it's not a token or not found
     return rawValue;
   }
 }

 // Recursively find a value in the route hierarchy, checking data first, then parameters.
 // Specifically looks within data.bindToComponentInputs if it exists.
 findData(route: ActivatedRoute, dataKey: string): any | null {
   const data = route.snapshot.data;
   // Check within bindToComponentInputs first
   if (data && data['bindToComponentInputs'] && data['bindToComponentInputs'].hasOwnProperty(dataKey)) {
     return data['bindToComponentInputs'][dataKey];
   }
   // Check direct data property
   if (data && data.hasOwnProperty(dataKey)) {
       return data[dataKey];
   }
   // Fallback to checking parameters if not found in data
   if (route.snapshot.paramMap.has(dataKey)) {
     return route.snapshot.paramMap.get(dataKey);
   }
   // Recurse up to the parent
   if (route.parent) {
     return this.findData(route.parent, dataKey);
   } else {
     return null;
   }
 }

   // Helper method to create a FormData object from a data object.
   createFormData(data: any, formData: FormData = new FormData(), parentKey: string = ''): FormData {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        const fullKey = parentKey ? `${parentKey}.${key}` : key;

        if (value instanceof File) {
          formData.append(fullKey, value);
        } else if (Array.isArray(value)) {
          if (value.length > 0 && value[0] instanceof File) {
            for (let i = 0; i < value.length; i++) {
              
              if(value[i] != null || value[i] != undefined)
                formData.append(fullKey, value[i]);
            }
          } else {
            for (let i = 0; i < value.length; i++) {
              this.createFormData(value[i], formData, `${fullKey}[${i}]`);
            }
          }
        } else if (typeof value === 'object' && value !== null) {
          this.createFormData(value, formData, fullKey);
        } else {
          if(value != null || value != undefined)
            formData.append(fullKey, value);
        }
      }
    }
    return formData;
  }

  reloadComponentUrl(router: Router): void {
    const currentUrl = router.url;
    router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      router.navigate([currentUrl]);
     });
   }

   /**
 * Parses a custom UTC date string (format "YYYY-MM-DD HH:mm:ss") into a Date object.
 * Assumes the input is in UTC and has no timezone offset.
 */
parseUTCDateString(utcDateString: string): Date {
  // Split the string into date and time components
  const [datePart, timePart] = utcDateString.split("T");

  // Extract year, month, day from the date part
  const [year, month, day] = datePart.split("-").map(Number);

  // Extract hours, minutes, seconds from the time part
  const [hours, minutes, seconds] = timePart.split(":").map(Number);

  // Create a Date object using UTC components
  // Note: Months are 0-based in JavaScript Dates (0 = January)
  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
}


}
